export const sensorsTmuyun = {
    /**
     *
     * @description 天目云事件 同步上报神策平台
     */
    reportPageView: (params: {
        /** 这个id要求为pubId */
        NewsArticleID: string

        /** 稿件id */
        SelfNewsArticleID: string

        /** 稿件标题 */
        NewsArticleTitle: string

        /** 稿件推送时间 */
        NewsArticlePubtime: string

        /** 频道id */
        NewsEditionNumber: string

        /** 频道名称 */
        NewsEditionName: string

        /** 稿件类型 */
        NewsArticleType?: string

        /** 稿件来源 */
        NewsArticleSource?: string

        /** 稿件作者 */
        NewsArticleAuthor?: string

        /** 稿件递送时间 */
        tmuPubTime: number

        /** 稿件过期时间 */
        tmuExpTime: number

        /** 稿件作者 */
        tmuAuthor: string

        position: string
    }) => {
        window['sensors'].track('SX_H5_APS0010', params)
    },
}
